import PubSub from "underpub-js";
import gsap from 'gsap';
import CustomEase from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);

var CardInfo = function (options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardInfo',
	};

	$.extend(true, this.options, options);

};

CardInfo.prototype.init = function () {

	var self = this;

	self.$image = self.options.$el.find(`.${self.options.baseClass}__image`);
	self.$heading = self.options.$el.find(`.${self.options.baseClass}__heading`);
	//	self.$copy = self.options.$el.find(`.${self.options.baseClass}__copy`);
	self.$copy = self.options.$el.find(`.${self.options.baseClass}__copy-outer`);
	//	self.$button = self.options.$el.find(`.${self.options.baseClass}__button`);

	self.initAnimation();

};

CardInfo.prototype.initAnimation = function () {

	var self = this;

	let breakpoint = window.Breakpoint.value;

	if (breakpoint == 'large' || breakpoint == 'xlarge') {

		self.animationTl = gsap
			.timeline({
				paused: true,
				defaults: {
					duration: 0.5,
					ease: "back.inOut(1.7)",
				}
			})
			.fromTo(self.$image,
				{
					scale: 1
				},
				{
					scale: 1.06
				}
			)
			.fromTo(self.$copy,
				{
					height: 0,
				},
				{
					height: "auto",
				}
				, "<");

		self.options.$el.on('mouseover', self.options.$el, function () {
			self.animationTl.play();
		}).on('mouseout', self.options.$el, function () {
			self.animationTl.reverse();
		});

	}

};

export default CardInfo;
